import { render } from "./Privacy-C007-En.vue?vue&type=template&id=720ace16&scoped=true"
const script = {}

import "./Privacy-C007-En.vue?vue&type=style&index=0&id=720ace16&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/mobile-mpe-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720ace16"]])

export default __exports__